import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/page_icons/exercise.svg'


const _withScopeId = n => (_pushScopeId("data-v-08490825"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "exercises" }
const _hoisted_2 = {
  id: "exercise-header",
  class: "row"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-2 page-icon" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row elements-centering" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "module logo"
    })
  ])
], -1))
const _hoisted_4 = {
  id: "exercise-title",
  class: "col-10"
}
const _hoisted_5 = {
  id: "container",
  class: "row"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1))
const _hoisted_7 = {
  id: "exercise-container",
  class: "col-10"
}
const _hoisted_8 = {
  key: 0,
  class: "row justify-content-center alert alert-warning",
  role: "alert"
}
const _hoisted_9 = {
  key: 1,
  class: "row justify-content-center alert alert-warning",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_ExerciseModule = _resolveComponent("ExerciseModule")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, { menus: true }),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t("PAGE.EXERCISES")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        (!_ctx.treatmentSet)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("HOME.TREATMENT_NOT_SET_1")), 1)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.treatmentSet)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("HOME.TREATMENT_NOT_SET_2")), 1)
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modules, (mod) => {
          return (_openBlock(), _createBlock(_component_ExerciseModule, {
            key: mod.id,
            module: mod,
            language: _ctx.language
          }, null, 8, ["module", "language"]))
        }), 128))
      ])
    ])
  ]))
}